import { useEffect, useRef } from 'react';

import { useTimeZone } from '@entities/datetime';

type Props = {
  filterKey?: string;
  currentFilter: URLSearchParams;
  updateFilter: (updates: object) => void;
};

export function useTimezoneParam({ currentFilter, updateFilter, filterKey = 'timezone' }: Props) {
  const currentTimeZone = useTimeZone();
  const key = filterKey;
  const isFirstRun = useRef(true);

  const filterTimeZone = currentFilter.get(key);
  if (!filterTimeZone) {
    updateFilter({ [key]: currentTimeZone });
  }

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    if (filterTimeZone !== currentTimeZone) {
      updateFilter({ [key]: currentTimeZone });
    }
  }, [currentTimeZone, filterTimeZone, key, updateFilter]);

  return {
    currentTimeZone,
    filterTimeZone,
  };
}
